import { apiWrapper } from 'ccs-ui-components';
import { call, fork, put, takeLatest } from 'redux-saga/effects';
import { headersInstance } from '../../../../common/utils/HeaderUtils';
import { sagaErrorConst } from '../../../constants';
import { IService, IServiceRequestModel } from '../../../models/index';
import { serviceResponseSchema } from '../../../utilities/sources/RegistriesSchemaDefintion';
import { createService } from '../../actions/actionType/services/ServiceActionTypes';
import {
  clearServiceData,
  createServiceFailure,
  createServiceStart,
  createServiceSuccessful
} from '../../actions/sagaActions/services/CreateServiceSagaActions';
import { FetchEventFailurePayload } from '../../actions/types/events/FetchEventDetailTypes';
import { CreateServiceRequest } from '../../actions/types/services/CreateUpdatedServiceTypes';

/**
 * Call create new service API
 * @param serviceName : string
 * @returns api response
 */
export async function callCreateServiceApi(
  serviceRequestBody: IServiceRequestModel
) {
  const resp = await apiWrapper.post<IService[], { errorMessage: string }>(
    `${process.env.REACT_APP_API_CONTROL_PLANE_SERVICE_BASE_URL}/services`,
    serviceRequestBody,
    headersInstance()
  );

  const apiResponse = serviceResponseSchema.validate(resp.responseBody, {
    abortEarly: true
  });

  if (resp.isError || !apiResponse.value) {
    return {
      errorMessage: resp.errorBody?.errorMessage,
      isError: resp.isError,
      statusCode: resp.statusCode
    };
  }
  const serviceData = resp.responseBody;
  return {
    serviceData,
    isError: resp.isError,
    statusCode: resp.statusCode
  };
}

/**
 * Saga to create new service
 * @param requestObject:IServiceRequestModel
 */
export function* createNewService({ requestObject }: CreateServiceRequest) {
  yield put(clearServiceData());
  yield put(createServiceStart());
  try {
    const { serviceData } = yield call(callCreateServiceApi, requestObject);
    if (serviceData) {
      yield put(createServiceSuccessful(serviceData));
    } else {
      const createEventErrorMessage = sagaErrorConst.createServiceMessage;
      throw new Error(createEventErrorMessage);
    }
  } catch (error) {
    const obj: FetchEventFailurePayload = {
      error: String(error)
    };
    yield put(createServiceFailure(obj));
  }
}

/**
 * Saga Effect to consider latest request
 */
export function* createServices() {
  yield takeLatest(createService.CREATE_SERVICE, createNewService);
}

export function* clearServiceDetails() {
  yield put(clearServiceData());
}

export function* clearServiceDetailsSaga() {
  yield takeLatest(createService.CLEAR_SERVICE_DETAILS, clearServiceDetails);
}

export const createServiceSaga = [fork(createServices)];
export const clearServiceSaga = [fork(clearServiceDetailsSaga)];
